export default {"src":"/_next/static/media/0xcf84a3dc12319531e3debd48c86e68eaeaff224a.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};